import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import CardsView from './RaceViews/CardsView.js'
import TimelineView from './RaceViews/TimelineView'
import { fadeInAnimation } from '../../utils/cssFunctions.js'
import HelmetMeta from '../../layouts/HelmetMeta'
import { useData } from '../../context/DataContext'

export default function Races () {
  const { t } = useTranslation('races')
  const [cardView] = useState(true)
  const { races, loading, error, refresh } = useData()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container sx={{ mt: 8, mb: 4 }} maxWidth='xl'>
      <HelmetMeta
        {...{
        title: t('metaTitle'),
        description: t('metaDescription'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />

      {/* Page title */}
      <Typography
        component='h1'
        sx={{
          fontSize: { xs: '1.5rem', md: '2rem' },
          fontWeight: 700,
          textAlign: 'center',
          mb: 6,
          pt: 4,
          ...fadeInAnimation
        }}
      >
        {t('pageTitle')}
      </Typography>

      {error && (
        <Alert
          severity='error' sx={{ mb: 3 }} action={
            <Button color='inherit' size='small' onClick={refresh}>{t('retry')}</Button>
        }
        >
          {t('loadError', { error })}
        </Alert>
      )}

      {loading && (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 3 }}>
          {[1, 2, 3].map(i => <Skeleton key={i} variant='rectangular' height={320} />)}
        </Box>
      )}

      {!loading && !error && cardView
        ? <Box
            sx={{
          height: cardView ? '100%' : 0,
          opacity: cardView ? 1 : 0,
          transition: 'opacity 300ms ease-in-out'
          // pointerEvents: cardView ? 'auto' : 'none'
        }}>
          <CardsView races={races} />
        </Box>
        : <Box
            sx={{
          height: cardView ? 0 : '100%',
          opacity: cardView ? 0 : 1,
          transition: 'opacity 300ms ease-in-out'
          // pointerEvents: cardView ? 'none' : 'auto'
        }}>
          <TimelineView data={races} />
        </Box>}
    </Container>
  )
}
